import React, { FC, useCallback, useEffect, useState } from "react";
import { LcardBadge } from "components/shared/lcard-badge";
import style from "./login.module.scss";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";
import {
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  Link,
  TextField,
  Typography,
} from "@material-ui/core";
import { CopyRights } from "components/shared/copyright";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useHistory } from "react-router-dom";
import { AppRoute } from "enums/appRoute";
import { UserAPI } from "adapters/user";
import { getConfig, http } from "adapters";
import * as yup from "yup";
import useLocalStorage from "react-use-localstorage";
import { Cookies } from "react-cookie";
import { SetConfigData } from "store/config/actions";
import { useDispatch } from "react-redux";
import { PageLoader } from "components/shared/loaders/page-loader";

const schema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().min(4).max(25).required(),
});

const Login: FC = () => {
  const [rememberMe, setRememberMe] = useState(false);
  const [, setToken] = useLocalStorage("token");
  const history = useHistory();
  const dispatch = useDispatch();

  const [cardId, setCardId] = useState<string | null>(null);
  const [type, setType] = useState<string | null>(null);

  const [, setCount] = useState(0);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const login = async (data: any) => {
    const response = await http.post(UserAPI.LOGIN, data);
    if (response.data.success) {
      setToken(response.data.accessToken);
      history.replace(AppRoute.HOME);
    }
  };

  const checkSession = useCallback(async () => {
    const cookies = new Cookies();
    const phpsessid = cookies.get("PHPSESSID");
    const ci_session = cookies.get("ci_session");

    const csData = {
      phpsessid: phpsessid,
      ci_session: ci_session,
    };
    const response = await http.post(UserAPI.CHECKSESSION, csData);
    console.log("check-session response:\n\n" + response);
    if (response.data.indexOf("nije_token") === -1) {
      setToken(response.data);
      getConfig().then((res) => {
        dispatch(SetConfigData(res.data));
        if (cardId && type === "url-designer")
          history.replace(AppRoute.URLDESIGNER.replace(":cardId", cardId));

        if (cardId && type === "enterprise")
          history.replace(
            AppRoute.URLTEMPLATEDESIGNER.replace(":cardId", cardId)
          );
      });
    } else {
      window.location.replace(window.location.origin + "/pro/index/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardId, history, type]);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  useEffect(() => {
    if (history.location.state) {
      if (
        (history.location.state as any).cardId &&
        !isNaN((history.location.state as any).cardId)
      ) {
        setCardId((history.location.state as any).cardId);
      }

      if ((history.location.state as any).type) {
        setType((history.location.state as any).type);
      }
    }
    setCount((prev) => prev + 1);
  }, [history.location.state]);

  return <PageLoader />;

  return (
    <div className={style.container}>
      <div className="d-flex justify-content_center">
        <LcardBadge />
      </div>
      <div className={style.card_container}>
        <Card>
          <form
            className={style.card_container__card}
            onSubmit={handleSubmit(login)}
          >
            <Typography
              className="text-align_center mb-4"
              variant="h4"
              gutterBottom
            >
              Login
            </Typography>
            <div className={style.card_container__card__inputs}>
              <TextField
                className="mb-4"
                {...register("email")}
                label="Email address"
                error={!!errors.email}
                helperText={errors.email?.message}
              />
              <TextField
                className="mb-4"
                {...register("password")}
                label="Password"
                type="password"
                error={!!errors.email}
                helperText={errors.password?.message}
              />
              <div className="d-flex justify-content_space-between aling-items_center mb-4">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={rememberMe}
                      onChange={(e) => setRememberMe(e.target.checked)}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label="Remember me"
                />
                <Link href="#" color="inherit">
                  Forgot password?
                </Link>
              </div>
            </div>
            <Button
              className={roundedButtonStyle.root}
              size="large"
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
            >
              Login
            </Button>
          </form>
        </Card>
        <div className="d-flex aling-items_center mt-4">
          <Typography className="mr-1" variant="caption">
            Don’t have an account yet?
          </Typography>
          <Link
            href="#"
            variant="subtitle1"
            onClick={() => history.push(AppRoute.SIGNUP)}
          >
            Create account
          </Link>
        </div>
      </div>
      <div className="d-flex justify-content_center">
        <CopyRights />
      </div>
    </div>
  );
};

export default Login;
